import React from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";


const UserCard = ({ info }) => {
  return (
    <div className="placeWrapper">
      <div className="image">
        <Link to={"/kategori-detay/"+info.id+"/"+ info.name}>
          <Image alt="User" src={info.image} />
          <div className="title">{info.name}</div>
        </Link>
      </div>
    </div>
  );
};

export default UserCard;
